export function cellByPos(x, y, cellSize) {
    return [Math.floor(x / cellSize), Math.floor(y / cellSize)];
}
